import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useStopLight } from './useStopLight';

interface OverlayTriggerStopLightProps {
	checklistColor: string;
	isGara?: boolean;
	isGaraTemp?: boolean;
}

const OverlayTriggerStopLight: React.FC<OverlayTriggerStopLightProps> = ({ checklistColor, isGara, isGaraTemp }) => {
	if (isGara) {
		checklistColor = 'grey';
	}
	if (isGaraTemp) {
		checklistColor = 'yellow';
	}
	const { icon, message } = useStopLight(checklistColor, isGara, isGaraTemp);

	// const { icon, message } = getIconAndMessage(checklistColor);
	return (
		<OverlayTrigger placement="top" overlay={<Tooltip>{message}</Tooltip>}>
			<span>{icon}</span>
		</OverlayTrigger>
	);
};

export default OverlayTriggerStopLight;
